import React from "react";
import { Route } from "react-router-dom";
import FinanceDashboard from "../../../pages/Views/CorporateResource/FinanceDashboard";
import {
	ArrearReports,
	ArrearReport2,
	FinancialReport2,
	PaymentsDueAlert,
	UncollectedReport,
	FinancialSummaryReport,
	RevenueReport,
	RevenueReport2,
} from "../../../pages/Views/CorporateResource/FinanceView/Reports";
import CollectPayment from "../../../pages/Views/CorporateResource/FinanceView/Forms/CollectPayment";
import AdvancePayment from "../../../pages/Views/CorporateResource/FinanceView/Forms/AdvancePayment";
import Invoice from "../../../pages/Views/CorporateResource/FinanceView/Forms/Invoice";
import FinanceRuleSettingsForm from "../../../pages/Views/CorporateResource/Head/Forms/FinanceRuleSettingsForm";
import ApproveImport from "../../../pages/Views/CorporateResource/Head/Forms/ApproveImport";
import ImportExistingCollection from "../../../pages/Views/CorporateResource/Head/ImportExistingCollection";
import ApprovalFinance from "../../../pages/Views/CorporateResource/FinanceView/Forms/ApprovalFinance";
import AdvancePaymentPrint from "../../../pages/Views/CorporateResource/FinanceView/Forms/AdvancePaymentPrint";
import PeriodicPaymentPrint from "../../../pages/Views/CorporateResource/FinanceView/Forms/PeriodicPaymentPrint";

export default function FinanceRoutes() {
	return (
		<>
			<Route path="/" element={<FinanceDashboard />} />
			<Route path="/arrear" element={<ArrearReport2 />} /> 
			<Route path="/advancepayment" element={<AdvancePayment  />} />
			<Route path="/advancepayment" element={<AdvancePayment  />} />
			<Route path="/collectPayment" element={<CollectPayment />} />
			<Route path="/financeSummary" element={<RevenueReport/>} />
			<Route path="/financialReports" element={<FinancialReport2 />} />
			<Route path="/paymentsDue" element={<PaymentsDueAlert />} />
			<Route path="/uncollected" element={<UncollectedReport />} />
			<Route path="/importExistingCollection" element={<ImportExistingCollection />} />
			<Route path="/financeRule" element={<FinanceRuleSettingsForm />} />
			<Route path="/approveImport" element={<ApproveImport />} />
			<Route path="/approvepaymenthead" element={< ApprovalFinance />} />
			<Route path="/invoice" element={<Invoice/>} />
			<Route path="/approveadvancepayment" element={<AdvancePaymentPrint/>} />
			<Route path="/approveperiodicalpayment" element={<PeriodicPaymentPrint/>} />

			
		</>
	);
}
